module.exports = __webpack_public_path__ + "img/logo-header.f95b16ec.svg";